import React from "react";

interface PlaybackControlsProps {
  onPlayPause: () => void;
  onSkipBackward: () => void;
  onSkipForward: () => void;
  skipSeconds?: number;
}

export const PlaybackControls: React.FC<PlaybackControlsProps> = ({
  onPlayPause,
  onSkipBackward,
  onSkipForward,
  skipSeconds = 3,
}) => {
  return (
    <>
      <div className="flex items-center justify-between text-gray-300 pt-3 border-t border-gray-700">
        <span className="text-white/70">Playback</span>
      </div>
      <button
        onClick={onPlayPause}
        className="w-full flex items-center justify-between px-3 py-2 rounded-sm bg-gray-800 hover:bg-gray-700 transition-colors"
      >
        <span className="text-gray-300">Play/Pause</span>
        <kbd className="px-2 py-1 bg-gray-900 rounded-sm text-white text-xs">Space</kbd>
      </button>
      <button
        onClick={onSkipBackward}
        className="w-full flex items-center justify-between px-3 py-2 rounded-sm bg-gray-800 hover:bg-gray-700 transition-colors"
      >
        <span className="text-gray-300">Skip back {skipSeconds}s</span>
        <kbd className="px-2 py-1 bg-gray-900 rounded-sm text-white text-xs">J</kbd>
      </button>
      <button
        onClick={onSkipForward}
        className="w-full flex items-center justify-between px-3 py-2 rounded-sm bg-gray-800 hover:bg-gray-700 transition-colors"
      >
        <span className="text-gray-300">Skip forward {skipSeconds}s</span>
        <kbd className="px-2 py-1 bg-gray-900 rounded-sm text-white text-xs">L</kbd>
      </button>
    </>
  );
};
